const BlockerFunctionRow = require('./BlockerFunctionRow.js');

class BlockerFunctionTester {
  constructor(rawRuleSets) {
    this.ruleSets = rawRuleSets.map((raw) => new BlockerFunctionRow(raw.rules));
  }
}

/**
 * tests against ruleSet
 *
 * @param string: str which should be tested against ruleset
 * @return bool: match or no match
 *
 */
BlockerFunctionTester.prototype.test = function(str) {
  let isBlocked = false;
  for(let ruleSet of this.ruleSets) {
    isBlocked |= (function(ruleSet) {
      if(ruleSet.rules.length === 0) return false;
      for(let rule of ruleSet.rules) if(rule.regexp.exec(str) == null) return false
      return true;
    })(ruleSet);
  }
  return isBlocked;
}

module.exports = BlockerFunctionTester;
